// Công tắc mục Kho (KHO_ERP_ENABLED) giữ ở kho nhỏ để cổng menu — hàm thường,
// không gọi hook được — đọc đồng bộ. Nạp bởi useKhoConfigSync (api.ts) ở
// useSidebarData. Tệp này KHÔNG được nhập máy khách API: cổng menu còn chạy
// trong kịch bản dựng bộ hướng dẫn (node, không có import.meta.env).
import { create } from "zustand";

interface KhoFlagState {
  enabled: boolean;
  setEnabled: (v: boolean) => void;
  /** Máy quét mượn/trả (KHO_SCANNER_ENABLED, kho-erp v1.4 §3.2). */
  scanner: boolean;
  setScanner: (v: boolean) => void;
}

export const useKhoFlag = create<KhoFlagState>((set) => ({
  enabled: false,
  setEnabled: (enabled) => set({ enabled }),
  scanner: false,
  setScanner: (scanner) => set({ scanner }),
}));
